<template>
  <div v-if="courses.length" class="course-slick-container">
    <div v-if="cardType == '3'" class="overlay"></div>
    <div
      v-if="
        (cardType == '1' && courses.length <= 3) ||
        ((cardType == '2' || cardType == '3') && courses.length <= 2)
      "
      class="flex flex-col lg:flex-row gap-8 mt-6"
    >
      <div
        v-for="course in courses"
        :key="course.key"
        class="item-margin w-full"
        :class="cardType == '1' ? ['item', 'lg:w-1/3'] : ['w-1/2']"
      >
        <template v-if="cardType == '1'">
          <CardCourse1 :content="course" />
        </template>
        <template v-else-if="cardType == '2'">
          <CardCourse2 :content="course" />
        </template>
        <template v-else-if="cardType == '3'">
          <Banner :content="course" />
        </template>
      </div>
    </div>
    <VueSlickCarousel
      v-else
      ref="carousel"
      v-bind="settings"
      class="course-slick-slider"
    >
      <div
        v-for="course in courses"
        :key="course.key"
        class="item-margin"
        :class="cardType == '1' ? 'item' : null"
      >
        <template v-if="cardType == '1'">
          <CardCourse1 :content="course" />
        </template>
        <template v-else-if="cardType == '2'">
          <CardCourse2 :content="course" />
        </template>
        <template v-else-if="cardType == '3'">
          <Banner :content="course" />
        </template>
      </div>
    </VueSlickCarousel>
    <div
      v-if="cardType == '1' && courses.length > 3"
      class="course-slick-arrow"
    >
      <button class="btn-prev focus:outline-none" @click="showPrev">
        <IconLeft />
      </button>
      <button class="btn-next focus:outline-none" @click="showNext">
        <IconRight />
      </button>
    </div>
  </div>
  <div v-else>
    <p class="text-center mt-10">No Data</p>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import CardCourse1 from '../1'
import CardCourse2 from '../2'
import IconLeft from '@/components/Icon/ChevronLeft'
import IconRight from '@/components/Icon/ChevronRight'
const Banner = () => import('@/components/App/Banner')

export default {
  props: {
    courses: {
      type: Array,
      // required: true,
    },
    settings: {
      type: Object,
      required: true,
    },
    cardType: {
      required: true,
    },
  },
  components: {
    VueSlickCarousel,
    CardCourse1,
    CardCourse2,
    Banner,
    IconLeft,
    IconRight,
  },
  methods: {
    showPrev() {
      this.$refs.carousel.prev()
    },
    showNext() {
      this.$refs.carousel.next()
    },
  },
}
</script>

<style lang="scss">
.course-slick-container {
  position: relative;
  // margin-left: 278px;
  .overlay {
    width: 100%;
    &:before {
      content: "";
      position: absolute;
      display: block;
      z-index: 1;
      top: 0;
      left: 0;
      width: 15%;
      height: 180px;
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0.6) 0.01%,
        rgba(255, 255, 255, 0) 100%
      );
    }

    &:after {
      content: "";
      position: absolute;
      display: block;
      z-index: 1;
      top: 0;
      right: 0;
      width: 15%;
      height: 180px;
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0.6) 0.01%,
        rgba(255, 255, 255, 0) 100%
      );
      transform: rotate(-180deg);
    }

    @media (min-width: 768px) {
      &:before,
      &:after {
        height: 270px;
      }
    }
  }

  .course-slick-slider {
    .slick-list {
      padding: 0 !important;
      .slick-track {
        padding: 20px 0;
      }
    }
    .slick-dots {
      bottom: -10px;
      text-align: right;
      li {
        margin: 0;
        button {
          padding: 0;
          width: 20px;
          height: 20px;
          &:before {
            font-size: 12px;
            // color: var(--kit-color-primary);
          }
        }
      }

      li.slick-active {
        button {
          &:before {
            opacity: 1;
            color: var(--kit-color-primary);
          }
        }
      }
    }
    .item {
      width: 300px !important;

      &-margin {
        margin-right: 30px;
      }
    }
  }

  &:hover {
    .course-slick-arrow {
      opacity: 1;
    }
  }

  .course-slick-arrow {
    opacity: 0;
    position: absolute;
    top: 44%;
    display: flex;
    width: 100%;
    padding: 0 14px;
    transition: opacity 0.2s ease-in-out;
    cursor: pointer;
    button {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: #ffffff;
      border: none;
      box-shadow: 0px 2px 30px rgba(57, 62, 66, 0.4);
      display: flex;
      justify-content: center;
      align-items: center;
      // cursor: pointer;
      z-index: 10;
    }

    .btn-prev {
      // position: absolute;
      left: 0;
    }
    .btn-next {
      // position: absolute;
      margin-left: auto;
      // right: 0;
    }
  }
}
</style>
